import React from 'react';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import ChecklistConfig from './checklist_config';
import ChecklistConfigsService from '../../services/checklist_configs_service';
import { PageTitle } from '../PageTitle';
import { Message } from '../Message';

class ChecklistEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      checklistId: props.match.params.checklistId,
      checklistConfiguration: null,
      saved: false,
      localErrorMessage: null,
      localSuccessMessage: null,
      submitting: false
    };
  }

  componentDidMount() {
    ChecklistConfigsService.get(this.state.checklistId).then((response) => {
      this.setState({checklistConfiguration: response.checklistConfiguration})
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-checklist-config') });
      console.error(error);
    });
  }

  handleLocalSuccess(localSuccessMessage) {
    this.setState({localSuccessMessage: localSuccessMessage});
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleLocalWarning(localWarningMessage) {
    this.setState({ localWarningMessage: localWarningMessage });
  }

  messageDismissCallback() {
    this.setState({
      localErrorMessage: null,
      localSuccessMessage: null
    });
  }

  renderMessages() {
    if (this.state.localWarningMessage) {
      return (
          <Message errorMessage={ this.state.localWarningMessage } messageDismissCallback={ this.messageDismissCallback.bind(this) } />
      );
    }

    if (this.state.localSuccessMessage) {
      return (
          <Message messages={{ state: { successMessage: this.state.localSuccessMessage } }} messageDismissCallback={ this.messageDismissCallback.bind(this) } />
      );
    }

    if (this.props.location.state) {
      return (
          <Message messages={ this.props.location } />
      );
    }
    return null;
  }

  handleSubmit(checklistConfiguration) {
    this.setState({submitting: true});

    this.messageDismissCallback();

    ChecklistConfigsService.save(this.state.checklistId, checklistConfiguration).then(_ => {
      this.setState({saved: true, submitting: false, successMessage: i18next.t('messages.checklist-saved')});
    }).catch(err => {
      console.error(err);
      this.setState({errorMessage: i18next.t('messages.error-saving-checklist')});
    })
  }

  handleArchive() {
    this.setState({submitting: true});
    ChecklistConfigsService.archive(this.state.checklistId).then(_ => {
      this.setState({saved: true, submitting: false, successMessage: i18next.t('messages.checklist-archived')})
    }).catch(err => {
      console.error(err);
      this.setState({errorMessage: i18next.t('messages.error-archiving-checklist')});
    })
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/config/checklists',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }
    
    if (this.state.saved) {
      return (
          <Redirect to={{
            pathname: '/config/checklists',
            state: {
              successMessage: this.state.successMessage
            }
          }}/>
      );
    }

    if (this.state.submitting) {
        return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    } 

    if (this.state.checklistConfiguration) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={i18next.t('pages.checklists.edit-checklist')}
                         backLinkWithParams={{
                           link: {
                             pathname: "/config/checklists",
                             search: backLinkSearch
                           }
                         }} />
            </div>
            {this.renderMessages()}
            <div className="op-content-box tree-form">
              <h4 className="remove-margin-bottom"/>
              <div className="row">
                <ChecklistConfig
                    originalChecklistConfiguration={this.state.checklistConfiguration}
                    onSubmit={ this.handleSubmit.bind(this) }
                    onArchive={ this.handleArchive.bind(this) }
                    onSuccess={ this.handleLocalSuccess.bind(this) }
                    onError={this.handleLocalError.bind(this)}
                    onWarning={this.handleLocalWarning.bind(this)}
                    backLinkWithParams={{
                      link: {
                        pathname: "/config/checklists",
                        search: backLinkSearch
                      }
                    }} />
              </div>
            </div>
          </div>
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

export default ChecklistEdit;
